export enum Events {
  LANGUAGE_CHANGED_EVENT = 'LANGUAGE_CHANGED_EVENT',
  IMPORT_MODAL_STATE = 'IMPORT_MODAL_STATE',
}
